<section class="px-xs !py-lg h-full overflow-y-auto bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Messages d'information</h3>
    <div hlmCardAction>
      <button (click)="ajouterMessage()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter un message
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Titre</th>
            <th hlmTh>Contenu</th>
            <th hlmTh>Période</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (message of messages(); track message.id) {
            <tr hlmTr>
              <td hlmTd>{{ message.titre }}</td>
              <td [innerHTML]="contenuSanitise(message.contenu)" hlmTd></td>
              <td hlmTd>{{ message.dateDebut | date: 'dd/MM/yyyy' }} - {{ message.dateFin | date: 'dd/MM/yyyy' }}</td>
              <td hlmTd>
                <button
                  [hlmDropdownMenuTrigger]="menu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: message }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</section>

<ng-template #menu let-ctx>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      <button (triggered)="modifierMessage(ctx)" hlmDropdownMenuItem>
        <ng-icon hlm name="lucidePen" size="sm" />
        Modifier le message
      </button>
      <button (triggered)="supprimerMessage(ctx)" hlmDropdownMenuItem>
        <ng-icon hlm name="lucideTrash" size="sm" />
        Supprimer le message
      </button>
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
